import { useTheme as useThemeBase } from '@emotion/react';
import { ITheme } from 'theme';

export function useTheme(): ITheme {
  return useThemeBase() as ITheme;
}
